import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: `
    <div class="app-spinner__container" [class.d-inline-flex]="inline" [class.size-auto]="inline">
      <mat-spinner [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-spinner>
    </div>
  `,
  styles: [`
    :host, .app-spinner__container {
      width: 100%;
      height: 100%;
    }

    .app-spinner__container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AppSpinnerComponent {
  @Input() diameter = 100;
  @Input() strokeWidth = 10;
  @Input() inline = false;

  constructor() { }
}
